module.exports = __webpack_public_path__ + "static/media/glygen-logoW-top.b97fab48.svg";